function applyDiscount(priceText, percent) {
  //applies discount using regex for when price elements contain a range, or multiple prices
  return priceText.replace(
    /(\$?)([0-9]+(\.[0-9][0-9])?)/g,
    function (match, currency, price) {
      newPrice = (price * (100 - percent)) / 100;
      return `${currency}${newPrice.toFixed(
        2,
      )} <span class="oldprice">${match}</span>`;
    },
  );
}

function applyDiscounts(percent) {
  console.log('in apply Discounts');
  Array.from(
    document.querySelectorAll(
      '.button-price:not(.no-pro):not(:has(.old)):not(:has(.oldprice))',
    ),
  ).forEach(function (element, index) {
    console.log('element', element);
    element.innerHTML = applyDiscount(element.innerHTML, percent);
    element.classList.add('no-pro'); //do not repeat discount on this element
  });
}

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(function (event) {
  const metaData = document.head.querySelector(
    'meta[name="kevynaucoin"]',
  ).dataset;

  if (metaData.pro) {
    const proDiscount = parseInt(metaData.proDiscount);
    const observerConf = { attributes: true, childList: true, subtree: true };
    const observerTarget = document.querySelector(
      '[id^="price-template"]:not(.no-pro)',
    );

    function onElementChange(mutations, observer) {
      observer.disconnect();
      applyDiscounts(proDiscount);
      observer.observe(observerTarget, observerConf);
    }

    applyDiscounts(proDiscount);

    const observer = new MutationObserver(onElementChange);
    observer.observe(observerTarget, observerConf);
  }
});
